<template>
    <div>
        <a href="#" class="alink" color="success" @click="reset">
            <v-icon color="success">mdi-plus-circle</v-icon>Add New Staff
        </a>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="700px"
            transition="dialog-bottom-transition"
            v-if="newform">
            <v-card>
                <v-card-title class="modal-card-title text-h6 font-weight-bold">
                <v-icon left>mdi-account-tie</v-icon>
                <span v-if="!editBtn">Add Staff</span>
                <span v-else>Update Staff</span>
                <v-spacer></v-spacer>
                <v-btn icon class="modal-close-btn" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </v-card-title>

                <v-card-text class="pt-6">
                    <v-form v-model="valid" ref="form">
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        outlined
                                        v-model="form.firstname"
                                        label="First Name"
                                        :rules="[v => !!v || 'First Name is required']"
                                        required
                                    ></v-text-field>
                                    <v-text-field
                                        outlined
                                        v-model="form.middlename"
                                        label="Middle Name (optional)"
                                    ></v-text-field>
                                    <v-text-field
                                        outlined
                                        v-model="form.lastname"
                                        label="Surname"
                                        :rules="[v => !!v || 'Surname is required']"
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select
                                        v-model="form.gender"
                                        outlined
                                        :items="gender"
                                        item-text="name"
                                        item-value="id"
                                        label="Gender (optional)"
                                    ></v-select>
                                    <v-select
                                        v-model="form.user_id"
                                        outlined
                                        clearable
                                        :items="availableUsers"
                                        item-text="fullname"
                                        item-value="id"
                                        label="Link to Login Account (optional)"
                                        hint="Allows this staff member to clock in/out and view their own attendance"
                                        persistent-hint
                                    ></v-select>
                                    <v-select
                                        v-model="form.status"
                                        v-if="editBtn"
                                        outlined
                                        :items="['active','inactive']"
                                        label="Status"
                                        class="mt-4"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-textarea
                                        outlined
                                        v-model="form.bio"
                                        label="Bio (optional)"
                                        rows="2"
                                    ></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn :disabled="!valid" color="success" rounded elevation="2"
                                    class="mr-2 px-6" @click="postRecord" v-if="!editBtn"
                                    >
                                        <v-icon left>mdi-check</v-icon>
                                        Create
                                    </v-btn>
                                    <v-btn :disabled="!valid" color="success" rounded elevation="2"
                                    class="mr-2 px-6" @click="updateRecord" v-else
                                    >
                                        <v-icon left>mdi-check</v-icon>
                                        Update
                                    </v-btn>
                                    <v-btn outlined rounded @click="closeDialog">
                                        <v-icon left>mdi-close</v-icon>
                                        Close
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'CreateTeacherForm',
    props:[
        'authToken',
        'school',
        'editFormSignal',
        'refreshRecordSignal',
    ],
    mounted() {
       this.getAvailableUsers()
    },
    data: () => ({
        newform: false,
        editBtn: false,
        form:{},
        gender:[
            {id:'0', name:'Male'},
            {id:'1', name:'Female'},
        ],
        availableUsers: [],
        valid: true,
        dialog:true
    }),
    watch:{
        editFormSignal(record){
            this.editRecord(record)
        },
        refreshRecordSignal(){
            this.getAvailableUsers()
        }
    },
    methods: {
        reset () {
            this.newform = true
            this.editBtn = false
            this.form = {}
        },
        closeDialog() {
            this.newform = false;
            this.editBtn = false;
            this.form = {}
        },
        getAvailableUsers () {
            axios.get(process.env.VUE_APP_BASEURL+'/teachers?school_id='+this.school.school_id+'&available_users=1',
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.availableUsers = response.data.data
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            });
        },
        postRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.post(process.env.VUE_APP_BASEURL+'/teachers?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.newform = false
                this.$emit("refresh");
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
        editRecord (record){
            this.newform = true
            this.form = {}
            this.form.id = record.id
            this.form.firstname = record.firstname
            this.form.middlename = record.middlename
            this.form.lastname = record.lastname
            this.form.gender = record.gender
            this.form.bio = record.bio
            this.form.status = record.status
            this.form.user_id = record.user_id
            if (record.user && !this.availableUsers.find(u => u.id === record.user.id)) {
                this.availableUsers.push(record.user)
            }
            this.editBtn = true
        },
        updateRecord () {
            let validation = this.$refs.form.validate()
            if(!validation) {
                return validation
            }
            let loader = this.$loading.show()
            axios.put(process.env.VUE_APP_BASEURL+'/teachers/'+this.form.id+'?school_id='+this.school.school_id,this.form,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$toast.success(response.data.message, {
                    timeout: 5000
                });
                this.newform = false
                this.editBtn = false
                this.$emit("refresh");
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                });
            })
            .finally(() => {
                loader.hide()
            });
        },
    },
  }
</script>
<style scoped>
.alink{
    text-decoration: none;
    font-weight: bolder;
}
</style>
